import { endpoints } from '../../Constants';
import { authHeader, toQueryStringURL } from '../../Helpers';
import handleResponse from '../helpers';

const printerConfigServices = {
	gateway,
};

function gateway({ req, method }) {
	switch (method) {
		case 'LIST':
			return listStore({
				req,
			});
		case 'ENABLE':
			return toggle({
				req,
			});
		default:
			break;
	}
	return new Promise();
}

function listStore({ req }) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.PRINTER_CONFIG, params);

	const requestOptions = {
		method: 'GET',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function toggle({ req }) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.PRINTER_CONFIG, params);

	const requestOptions = {
		method: 'PATCH',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(url, requestOptions).then(handleResponse);
}
export default printerConfigServices;
